/* ============================================================================
   MACHANG — The Studio (AI stylist) for the Liquid theme.
   Look builder + avatar try-on over real store products.
   "Generation" is simulated with a short delay today; to make it real, replace
   generateLook()/generateTryOn() bodies with a fetch() to a Shopify App Proxy
   (e.g. /apps/studio/look) that calls your image/style model and returns
   product handles + a rendered try-on image.
   Add-to-bag uses the theme's Cart API via window.MACHANG routes.
   ========================================================================== */
(function () {
  "use strict";
  var root = document.getElementById("StudioApp");
  if (!root) return;
  var DATA = (window.MACHANG_STUDIO && window.MACHANG_STUDIO.products) || [];
  var CFG = window.MACHANG || {};
  var routes = CFG.routes || {};

  // Occasion -> how to pick pieces from the live catalog (by tag/type keywords).
  var OCCASIONS = {
    "Yacht day": { match: ["linen", "set", "resort", "knit"], reason: "Breathable linen and warm resort tones to keep you cool under the sun while still reading expensive on deck." },
    "Rooftop night": { match: ["satin", "silk", "knit", "shirt"], reason: "Satin and silk with a subtle shimmer that catch the skyline lights — sharp for dinner, easy for the after-party." },
    "Brunch": { match: ["set", "knit", "resort", "linen"], reason: "Relaxed co-ords and fine knit for long daytime tables that roll into golden hour." },
    "Club night": { match: ["disco", "sheer", "palms", "shirt"], reason: "High-shine and sheer layering engineered for the strobe. Built to move, built to be seen." }
  };
  var BUILDS = ["Slim", "Athletic", "Broad"];
  var VIBES = ["Party", "Minimal", "Luxe", "Street"];
  var SKINS = ["#f1dcc4", "#dcb78d", "#b6885c", "#7d5738"];

  var st = {
    tab: "look", occasion: "Rooftop night", genLook: false, lookItems: null, lookReason: "", lookOccasion: "",
    avatar: { build: "Athletic", height: 178, skin: "#dcb78d", vibe: "Party" }, avatarBuilt: false,
    tryOnId: DATA[0] && DATA[0].handle, genTry: false, tryOnResult: false
  };
  var lookTimer, tryTimer;

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function money(cents) {
    var fmt = CFG.moneyFormat || "AED {{amount}}";
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 2 }));
  }
  function byHandle(h) { return DATA.filter(function (p) { return p.handle === h; })[0]; }
  function pickLook(occ) {
    var conf = OCCASIONS[occ] || OCCASIONS["Rooftop night"];
    var scored = DATA.map(function (p) {
      var hay = (p.title + " " + (p.type || "") + " " + (p.tags || []).join(" ")).toLowerCase();
      var score = conf.match.reduce(function (a, k) { return a + (hay.indexOf(k) >= 0 ? 1 : 0); }, 0);
      return { p: p, score: score };
    }).sort(function (a, b) { return b.score - a.score; });
    var chosen = scored.filter(function (s) { return s.score > 0; }).slice(0, 3).map(function (s) { return s.p; });
    while (chosen.length < 3 && DATA[chosen.length]) { if (chosen.indexOf(DATA[chosen.length]) < 0) chosen.push(DATA[chosen.length]); else break; }
    return { items: chosen, reason: conf.reason };
  }

  function toast(msg) {
    var host = document.getElementById("ToastHost");
    if (!host) return;
    host.innerHTML = '<div class="toast"><span class="ok">✓</span>' + esc(msg) + "</div>";
    setTimeout(function () { host.innerHTML = ""; }, 2200);
  }
  function addToCart(variantId, qty) {
    if (!variantId || !routes.cart_add_url) { toast("Connect products to add to bag"); return Promise.resolve(); }
    return fetch(routes.cart_add_url + ".js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function () {
      var counts = document.querySelectorAll("[data-cart-count]");
      counts.forEach(function (c) { c.hidden = false; c.textContent = (parseInt(c.textContent, 10) || 0) + (qty || 1); });
    });
  }

  var PROXY_BASE = (window.MACHANG_STUDIO && window.MACHANG_STUDIO.proxyBase) || "/apps/studio";
  function proxyPost(path, body) {
    return fetch(PROXY_BASE + path, {
      method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body),
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function generateLook() {
    st.genLook = true; st.lookItems = null; render();
    clearTimeout(lookTimer);
    function fallback() {
      var L = pickLook(st.occasion);
      st.genLook = false; st.lookItems = L.items; st.lookReason = L.reason; st.lookOccasion = st.occasion; render();
    }
    var payload = {
      occasion: st.occasion, avatar: st.avatar,
      products: DATA.map(function (p) { return { handle: p.handle, title: p.title, price: p.price, type: p.type, tags: p.tags }; }),
    };
    // Try the AI app proxy; fall back to local keyword styling if unavailable.
    proxyPost("/look", payload).then(function (res) {
      if (res && res.ok && res.picks && res.picks.length) {
        var items = res.picks.map(byHandle).filter(Boolean);
        if (items.length < 3) return fallback();
        st.genLook = false; st.lookItems = items; st.lookReason = res.reason || pickLook(st.occasion).reason; st.lookOccasion = st.occasion; render();
      } else { fallback(); }
    }).catch(fallback);
  }
  function generateTryOn() {
    if (!st.avatarBuilt) { toast("Build your avatar first"); return; }
    st.genTry = true; st.tryOnResult = false; st.tryOnImage = null; render();
    clearTimeout(tryTimer);
    var tp = byHandle(st.tryOnId) || DATA[0];
    function done() { st.genTry = false; st.tryOnResult = true; render(); }
    proxyPost("/tryon", { avatar: st.avatar, productTitle: tp.title, garmentImage: tp.image }).then(function (res) {
      if (res && res.ok && res.imageUrl) st.tryOnImage = res.imageUrl;
      done();
    }).catch(done);
  }

  function avatarFig(size) {
    var w = size === "sm" ? 110 : 120, h = size === "sm" ? 184 : 200;
    return '<div class="avatar-fig" style="width:' + w + "px;height:" + h + "px;margin:0 auto 14px;background:linear-gradient(160deg," + st.avatar.skin + ", color-mix(in srgb," + st.avatar.skin + ' 60%, #000))"><div class="torso"></div></div>';
  }

  function render() {
    if (!DATA.length) {
      root.innerHTML = '<div style="border:1px dashed var(--line);border-radius:var(--r);padding:40px;text-align:center;color:var(--muted2)">Add products to the Studio collection to start styling looks.</div>';
      return;
    }
    var tabs = '<div class="studio-tabs">' +
      '<button class="' + (st.tab === "look" ? "is-active" : "") + '" data-tab="look">Create a look</button>' +
      '<button class="' + (st.tab === "tryon" ? "is-active" : "") + '" data-tab="tryon">See it on me</button></div>';
    root.innerHTML = tabs + (st.tab === "look" ? lookTab() : tryTab());
  }

  function lookTab() {
    var occs = Object.keys(OCCASIONS).map(function (o) {
      return '<button class="occ-opt' + (st.occasion === o ? " is-active" : "") + '" data-occ="' + esc(o) + '">' + (st.occasion === o ? "✓ " : "") + esc(o) + "</button>";
    }).join("");
    var block = "";
    if (st.genLook) {
      block = '<div style="display:flex;align-items:center;gap:12px;margin-bottom:18px;color:var(--muted2);font:600 14px var(--font-body)"><span class="spinner"></span>Styling your look…</div>' +
        '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:18px;max-width:720px"><div style="aspect-ratio:3/4;background:var(--bg2);border-radius:var(--r)"></div><div style="aspect-ratio:3/4;background:var(--bg2);border-radius:var(--r)"></div><div style="aspect-ratio:3/4;background:var(--bg2);border-radius:var(--r)"></div></div>';
    } else if (st.lookItems) {
      var items = st.lookItems.map(function (p) {
        var media = p.image ? 'background-image:url(' + p.image + ');background-size:cover' : "";
        return '<a href="' + p.url + '" style="text-decoration:none;color:inherit"><div style="aspect-ratio:3/4;border-radius:calc(var(--r) - 3px);' + media + ';background-color:var(--bg2);display:flex;align-items:center;justify-content:center">' + (p.image ? "" : '<span class="mono-note">shot</span>') + "</div>" +
          '<div style="font-weight:600;font-size:12px;margin-top:7px;line-height:1.2">' + esc(p.title) + '</div><div style="font-weight:700;font-size:12px;color:var(--muted2)">' + esc(p.priceFmt) + "</div></a>";
      }).join("");
      var total = st.lookItems.reduce(function (a, p) { return a + p.price; }, 0);
      var fig = st.avatarBuilt
        ? '<div style="text-align:center;padding:16px">' + avatarFig("sm") + '<div style="font-size:11px;color:var(--muted)">' + st.avatar.build + " · " + st.avatar.height + " cm · " + st.avatar.vibe + "</div></div>"
        : '<div style="text-align:center;padding:22px"><div style="font-size:34px;margin-bottom:10px">✦</div><div style="font:600 13px var(--font-body);color:var(--muted2);max-width:190px;margin:0 auto 14px">Build your avatar to see this look on you.</div><button class="btn btn-outline btn-sm" style="border-color:var(--a1);color:var(--a1)" data-tab="tryon">Build avatar →</button></div>';
      block = '<div class="look-result"><div class="look-figure"><span style="position:absolute;top:14px;left:14px;font:700 10px var(--font-mono);letter-spacing:.14em;color:var(--a1)">✦ ON YOU</span>' + fig + "</div>" +
        '<div><div style="display:flex;align-items:center;gap:10px;margin-bottom:6px"><span style="background:var(--a1);color:#0b0b0d;font:700 10px var(--font-body);letter-spacing:.1em;padding:4px 9px;border-radius:var(--rs)">YOUR LOOK</span><span style="font:700 15px var(--font-display)">' + esc(st.lookOccasion) + "</span></div>" +
        '<p style="font-size:14px;line-height:1.55;color:rgba(244,242,234,.75);margin:0 0 18px">' + esc(st.lookReason) + "</p>" +
        '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px">' + items + "</div>" +
        '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;border-top:1px solid var(--line);padding-top:18px">' +
        '<div style="font:700 18px var(--font-display)">Complete look · ' + money(total) + '</div><button class="btn btn-primary btn-sm" data-addlook="1">Add look to bag →</button></div></div></div>';
    }
    return '<div class="studio-card"><div style="display:flex;align-items:center;gap:10px;margin-bottom:18px"><span class="step-num">1</span><div style="font:700 19px var(--font-display)">Where are you headed?</div></div>' +
      '<div class="occasion-opts">' + occs + "</div>" +
      '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:14px;border-top:1px solid var(--line);padding-top:20px">' +
      '<div style="font-size:13px;color:var(--muted);max-width:360px;line-height:1.45">' + (CFG.shopName || "Machang") + ' picks three pieces that work together for your night — ready to add in one tap.</div>' +
      '<button class="btn btn-primary" data-genlook="1">✦ Create my look</button></div></div>' + block;
  }

  function tryTab() {
    var builds = BUILDS.map(function (b) { return '<button class="size-opt' + (st.avatar.build === b ? " is-selected" : "") + '" style="flex:1;min-width:0" data-build="' + b + '">' + b + "</button>"; }).join("");
    var vibes = VIBES.map(function (v) { return '<button class="filter' + (st.avatar.vibe === v ? " is-active" : "") + '" data-vibe="' + v + '">' + v + "</button>"; }).join("");
    var skins = SKINS.map(function (s) { return '<button class="swatch' + (st.avatar.skin === s ? " is-on" : "") + '" style="background:' + s + '" data-skin="' + s + '"></button>'; }).join("");
    var tryItems = DATA.slice(0, 8).map(function (p) {
      var on = st.tryOnId === p.handle;
      var media = p.image ? 'background-image:url(' + p.image + ');background-size:cover' : "background:repeating-linear-gradient(45deg,var(--bg2),var(--bg2) 7px,rgba(255,255,255,.03) 7px,rgba(255,255,255,.03) 14px)";
      return '<div data-try="' + p.handle + '" style="cursor:pointer;aspect-ratio:3/4;border-radius:calc(var(--r) - 4px);border:' + (on ? "2px solid var(--a1)" : "1px solid var(--line)") + ";" + media + ';display:flex;align-items:flex-end;padding:6px"><span style="font:' + (on ? "700" : "600") + " 9px var(--font-body);color:" + (on ? "var(--fg)" : "var(--muted)") + ';background:rgba(11,11,13,.5);padding:2px 4px;border-radius:4px">' + esc(p.title) + "</span></div>";
    }).join("");
    var stage;
    if (st.tryOnResult) {
      var tp = byHandle(st.tryOnId) || DATA[0];
      var figure = st.tryOnImage
        ? '<img src="' + st.tryOnImage + '" alt="Try-on of ' + esc(tp.title) + '" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0;border-radius:var(--r)">'
        : avatarFig();
      stage = '<div style="text-align:center;padding:20px;animation:pop .4s ease;position:relative;z-index:1"><span style="position:absolute;top:16px;left:16px;font:700 10px var(--font-mono);letter-spacing:.14em;color:var(--a1);z-index:2">✦ AI TRY-ON</span>' + figure +
        (st.tryOnImage ? "" : '<div style="font:700 15px var(--font-display)">Wearing ' + esc(tp.title) + '</div><div style="font-size:12px;color:var(--muted2);margin-top:4px">' + st.avatar.build + " · " + st.avatar.height + " cm · " + st.avatar.vibe + "</div>") + "</div>";
    } else if (st.genTry) {
      stage = '<div style="text-align:center;color:var(--muted2)"><div class="spinner" style="width:26px;height:26px;border-width:3px;margin-bottom:12px"></div><div style="font:600 14px var(--font-body)">Rendering the fit on you…</div></div>';
    } else {
      stage = '<div style="text-align:center;color:var(--muted);padding:30px"><div style="font-size:40px;margin-bottom:12px">✦</div><div style="font:600 14px var(--font-body);max-width:220px">Build your avatar on the left, then see any piece on you.</div></div>';
    }
    return '<div class="try-grid"><div>' +
      '<div style="font:700 20px var(--font-display);margin-bottom:16px">1 · Build your avatar</div>' +
      '<div style="font:600 12px var(--font-body);color:var(--muted2);margin-bottom:8px">Build</div><div style="display:flex;gap:8px;margin-bottom:18px">' + builds + "</div>" +
      '<div style="display:flex;justify-content:space-between;font:600 12px var(--font-body);color:var(--muted2);margin-bottom:8px"><span>Height</span><span style="color:var(--a1)">' + st.avatar.height + ' cm</span></div>' +
      '<input type="range" min="160" max="205" value="' + st.avatar.height + '" data-height="1" style="width:100%;accent-color:var(--a1);margin-bottom:18px"/>' +
      '<div style="font:600 12px var(--font-body);color:var(--muted2);margin-bottom:8px">Skin tone</div><div style="display:flex;gap:10px;margin-bottom:18px">' + skins + "</div>" +
      '<div style="font:600 12px var(--font-body);color:var(--muted2);margin-bottom:8px">Style vibe</div><div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:24px">' + vibes + "</div>" +
      '<button class="btn btn-outline btn-block" style="border-color:var(--a1);color:var(--a1)" data-buildavatar="1">Generate my avatar</button>' +
      '<div style="font:700 20px var(--font-display);margin:30px 0 14px">2 · Pick a piece to try on</div>' +
      '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px">' + tryItems + "</div></div>" +
      '<div style="position:sticky;top:90px"><div class="look-figure" style="aspect-ratio:3/4">' + stage + "</div>" +
      '<button class="btn btn-primary btn-block" style="margin-top:14px" data-tryon="1">See it on me →</button>' +
      '<div style="text-align:center;font-size:11px;color:rgba(244,242,234,.4);margin-top:10px">AI-generated preview · final fit may vary</div></div></div>';
  }

  root.addEventListener("click", function (e) {
    var t = e.target.closest("[data-tab],[data-occ],[data-genlook],[data-addlook],[data-build],[data-vibe],[data-skin],[data-buildavatar],[data-tryon],[data-try]");
    if (!t) return;
    var d = t.dataset;
    if (d.tab) { st.tab = d.tab; return render(); }
    if (d.occ) { st.occasion = d.occ; return render(); }
    if (d.genlook !== undefined) return generateLook();
    if (d.addlook !== undefined) {
      var chain = Promise.resolve();
      (st.lookItems || []).forEach(function (p) { chain = chain.then(function () { return addToCart(p.variantId, 1); }); });
      return chain.then(function () { toast("Look added to bag"); });
    }
    if (d.build) { st.avatar.build = d.build; st.avatarBuilt = false; st.tryOnResult = false; return render(); }
    if (d.vibe) { st.avatar.vibe = d.vibe; st.avatarBuilt = false; st.tryOnResult = false; return render(); }
    if (d.skin) { st.avatar.skin = d.skin; st.avatarBuilt = false; st.tryOnResult = false; return render(); }
    if (d.buildavatar !== undefined) { st.avatarBuilt = true; st.tryOnResult = false; toast("Avatar ready"); return render(); }
    if (d.tryon !== undefined) return generateTryOn();
    if (d.try) { st.tryOnId = d.try; st.tryOnResult = false; return render(); }
  });
  root.addEventListener("input", function (e) {
    if (e.target.dataset && e.target.dataset.height !== undefined) { st.avatar.height = parseInt(e.target.value, 10); st.avatarBuilt = false; st.tryOnResult = false; render(); }
  });

  render();
})();
